import { toast } from "sonner";

export async function updateTimeValue(timeValueData, id) {
    const token = sessionStorage.getItem('token'); // Retrieve the JWT token from session storage
    const headers = {
        'Authorization': `Bearer ${token}`, // Pass the token in the Authorization header
        'Content-Type': 'application/json'
    };
    const putUrl = `${process.env.REACT_APP_API_URL}/admin/profesor/valorhora/actualizar/${id}`;

    try {
        const putResponse = await fetch(putUrl, {
            method: 'PUT',
            headers: headers,
            body: JSON.stringify(timeValueData) // Convert the time value data to JSON
        });

        const contentType = putResponse.headers.get('content-type');
        const responseText = await putResponse.text(); // Read the response as text

        if (!putResponse.ok) {
            console.error('Server responded with:', responseText);
            throw new Error('Failed to update time value');
        }

        if (contentType && contentType.includes('application/json')) {
            toast.success("Nómina actualizada exitosamente");
            return JSON.parse(responseText); // Attempt to parse the response as JSON
        } else {
            console.log('Response is not JSON:', responseText);
            toast.success("Nómina actualizada exitosamente");
            return { message: responseText }; // Return the response text as a message
        }

    } catch (error) {
        toast.error("Error al actualizar la nómina: " + error.message);
        throw new Error(`Failed to update time value: ${error.message}`);
    }
}